import React, { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import './CSP.scss'
import MainButton from '../../../components/MainButton/MainButton';
import gearIcon from '../../../static/img/gear_icon.png'
import ScrollContainer from "react-indiana-drag-scroll";

export default function CSP() {
  const [image, setImage] = useState(null);
  const [coordinates, setCoordinates] = useState([]);
  const [polygons, setPolygons] = useState([]);
  const [strokeWidth, setStrokeWidth] = useState(2);
  const [snapDistance, setSnapDistance] = useState(5);

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const imageUrl = URL.createObjectURL(file);
      setImage(imageUrl);
      setCoordinates([]);
    }
  };

  const handleImageClick = (event) => {

    const rect = event.target.getBoundingClientRect();
    const x = event.clientX - rect.left;
    const y = event.clientY - rect.top;

    let newCoordinates = { x: Math.round(x), y: Math.round(y) };

    const SNAP_DISTANCE = snapDistance;

    polygons.forEach((polygon) => {
      polygon.points.forEach((point) => {
        const distance = Math.sqrt(
          Math.pow(newCoordinates.x - point.x, 2) + Math.pow(newCoordinates.y - point.y, 2)
        );
  
        if (distance <= SNAP_DISTANCE) {
          newCoordinates = { x: point.x, y: point.y };
        }
      });
    });

    const updatedCoordinates = [...coordinates, newCoordinates];
    setCoordinates(updatedCoordinates);

    const coordsText = updatedCoordinates.map(coord => `[${coord.x}, ${coord.y}],`).join('\n');

    navigator.clipboard.writeText(coordsText).catch((err) => {
      console.error("Error copying coords:", err);
    });
  };

  const handleResetCoordinates = () => {
    setCoordinates([]);
  };

  const handleUndo = useCallback(() => {
    setCoordinates((prev) => prev.slice(0, -1));
  }, []);

  const handleSavePolygon = useCallback(() => {
    if (coordinates.length > 0) {
      const polygonId = `Polygon ${polygons.length + 1}`;
      const newPolygon = { id: polygonId, points: [...coordinates] };
      setPolygons([...polygons, newPolygon]);
      setCoordinates([]);
    }
  }, [coordinates, polygons]);

  const handlePolygonsDelete = () => {
    setPolygons([]);
  }

  const handleKeyDown = useCallback((event) => {
    if (event.ctrlKey && event.key === "q") {
      event.preventDefault();
      handleSavePolygon();
    }

    if (event.ctrlKey && event.key === "z") {
      event.preventDefault();
      handleUndo();
    }
  }, [handleSavePolygon, handleUndo]);

  const handleDeletePolygon = (id) => {
    setPolygons(polygons.filter(polygon => polygon.id !== id));
  };

  useEffect(() => {
    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [handleKeyDown]);

  const strokeWidthChange = (event) => {
    const newStrokeWidth = parseInt(event.target.value, 10);
    if (!isNaN(newStrokeWidth)) {
      setStrokeWidth(newStrokeWidth);
    }
  };

  const snapDistanceChange = (event) => {
    const newSnapDistance = parseInt(event.target.value, 10);
    if (!isNaN(newSnapDistance)) {
      setSnapDistance(newSnapDistance);
    }
  };

  const points = coordinates.map((coord) => `${coord.x},${coord.y}`).join(" ");

  return (
    <div className="wrapper">
      <header className="header">
        <Link to="/">
          <img src={gearIcon} alt="main-menu" />
        </Link>
        <span>
          File
          <input
            type="file"
            accept="image/*"
            onChange={handleImageChange}
          />
        </span>
      </header>
      <div className="info">
        <h1>Create SVG Polygon</h1>
        <div className="info-span">
          <span>1. Select render image</span>
          <span>2. Use zoom (ctrl + mouse wheel)</span>
          <span>3. Click on image</span>
          <span>4. All coordinates are copied to the clipboard</span>
          <span>5. Use "Undo" button or ctrl + z to remove last point</span>
          <span>6. Use "Reset Coordinates" to clear all points</span>
          <span>7. Use "Save Element" (ctrl + q) to save elements</span>
          <span>8. Use "Delete All Elements" to delete all elements</span>
        </div>
      </div>
      {/* <div className="cords">
        <span>Coordinates: </span>
        <span>
          {Array.isArray(coordinates) && coordinates.length > 0
            ? coordinates.map((coord, index) => (
                <span key={index}>
                  {coord.x},{coord.y}{" "}
                  {index < coordinates.length - 1}
                </span>
              ))
            : "No coordinates yet"}
        </span>
      </div> */}
      <aside className="menu">
        <MainButton title={"🡠 CSM"} link={"/create-svg-marker"}/>
        <span className='elements-menu-heading'>Elements</span>
        {polygons.length === 0 ? (
          <></>
        ) : (
          <ul>
            {polygons.map((polygon) => (
              <li key={polygon.id}>
                <span>{polygon.id}</span>
                <button onClick={() => handleDeletePolygon(polygon.id)}>Delete</button>
              </li>
            ))}
          </ul>
        )}
      </aside>
      <aside className="controls">
        <span className='inspector-heading'>Inspector</span>
        <div className="btns">
          <button onClick={handleUndo} disabled={coordinates.length === 0}>Undo (Ctrl+Z)</button>
          <button onClick={handleResetCoordinates} disabled={coordinates.length === 0}>Reset Coordinates</button>
          <button onClick={handleSavePolygon} disabled={coordinates.length === 0}>
            Save Element
          </button>
          <button onClick={handlePolygonsDelete} disabled={polygons.length === 0}>Delete All Elements</button>
        </div>
        <div className="input-con">
          <label>Stroke Width</label>
          <input type="text" onChange={strokeWidthChange} placeholder={strokeWidth}/>
        </div>
        <div className="input-con">
          <label>Snap Distance</label>
          <input type="text" onChange={snapDistanceChange} placeholder={snapDistance}/>
        </div>
      </aside>
      {/* <div
       className="img-container" 
       style={{position: 'relative'}}
      >
        {image && (
          <>
            <img
              src={image}
              alt="Selected"
              onClick={handleImageClick}
            />
            <svg
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                pointerEvents: "none",
              }}
            >
              <polyline
                points={points}
                fill="none"
                stroke="yellow"
                strokeWidth="2"
              />
            </svg>
          </>
        )}
      </div> */}
      <div className="img-container" style={{ position: 'relative' }}>
        {image && (
          <>
            <img src={image} alt="Selected" onClick={handleImageClick}/>
            <svg
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                pointerEvents: 'none',
              }}
            >
              {coordinates.length > 0 && (
                <polyline
                  points={coordinates.map(coord => `${coord.x},${coord.y}`).join(' ')}
                  fill="none"
                  stroke="yellow"
                  strokeWidth={strokeWidth}
                />
              )}
              {polygons.map((polygon) => (
                <polygon
                  key={polygon.id}
                  points={polygon.points.map(coord => `${coord.x},${coord.y}`).join(' ')}
                  fill="rgba(255,255,0,0.2)"
                  stroke="yellow"
                  strokeWidth={strokeWidth}
                />
              ))}
            </svg>
          </>
        )}
      </div>
    </div>
  );
}